import React from 'react';
import TinyComments from '../../../components/TinyComments/TinyComments';
import CommentsApiService from '../../../core/services/comments-api-service';

import './OverviewInformation.scss';

const apiServicePrev = new CommentsApiService('Previous');
const apiServiceToday = new CommentsApiService('Today');

export default function OverviewInformation(): JSX.Element {
  const isAdmin = Boolean(sessionStorage.getItem('isAdmin') || false);
  const isClient = Boolean(sessionStorage.getItem('viewAsClient'));

  return (
    <div className="OverviewInformation">
      <div className="row">
        <div className="OverviewInformation__block col-md-6">
          <h3>Previous Session</h3>
          <TinyComments
            disabled={!isAdmin || isClient}
            multiple={false}
            wordLimit={1000}
            apiService={apiServicePrev}
          />
        </div>
        <div className="OverviewInformation__block col-md-6">
          <h3>Today’s Session</h3>
          <TinyComments
            disabled={!isAdmin || isClient}
            multiple={false}
            wordLimit={1000}
            apiService={apiServiceToday}
          />
        </div>
      </div>
    </div>
  );
}
